var _linearGradient;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoVoryq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uADF8\\uB8F9 230",
    xmlns: "http://www.w3.org/2000/svg",
    width: 207.494,
    height: 40,
    viewBox: "0 0 207.494 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "u38goe8lva"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 6365",
    style: {
      fill: "none"
    },
    d: "M0 0h207.494v40H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ppacnkilvb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 174",
    d: "M50.071 19.463a4.106 4.106 0 0 0 .561 5.779 11.83 11.83 0 0 1 3.8 12.533 5.816 5.816 0 0 0-7.966 7.912 11.809 11.809 0 0 1-10.848-2.205 4.106 4.106 0 1 0-5.219 6.34 19.872 19.872 0 0 0 12.689 4.566q.98 0 1.97-.1a19.912 19.912 0 0 0 9.437-3.438 4.362 4.362 0 1 0 5.078-5.072A20.024 20.024 0 0 0 55.85 18.9a4.106 4.106 0 0 0-5.779.561",
    transform: "translate(-28.903 -17.966)",
    style: {
      fill: "none"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y53xc5kr7c",
    x1: 0.048,
    y1: 0.855,
    x2: 0.052,
    y2: 0.855,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd34b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#ffca44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc13d"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 225"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 224",
    style: {
      clipPath: "url(#u38goe8lva)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 165",
    d: "M406.1 59.244a2.357 2.357 0 0 1-2.354-2.354V39.117a2.354 2.354 0 1 1 4.709 0V56.89a2.357 2.357 0 0 1-2.354 2.354",
    transform: "translate(-324.231 -29.523)",
    style: {
      fill: "#5c626d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 166",
    d: "M458.772 59.244a3.824 3.824 0 0 1-3.576-2.432l-6.587-16.673a2.469 2.469 0 0 1 2.3-3.376 2.479 2.479 0 0 1 2.316 1.612L459 53.987l5.8-15.737a2.282 2.282 0 0 1 2.133-1.488 2.274 2.274 0 0 1 2.114 3.109l-6.693 16.94a3.824 3.824 0 0 1-3.576 2.432",
    transform: "translate(-360.12 -29.523)",
    style: {
      fill: "#5c626d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 167",
    d: "M576.11 57.4c-7.042 0-12.153-4.969-12.153-11.816s5.111-11.814 12.153-11.814 12.153 4.969 12.153 11.816S583.152 57.4 576.11 57.4m0-19.429a7.283 7.283 0 0 0-7.444 7.613 7.446 7.446 0 1 0 14.888 0 7.283 7.283 0 0 0-7.444-7.613",
    transform: "translate(-452.894 -27.12)",
    style: {
      fill: "#5c626d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 168",
    d: "M822.656 59.244a2.357 2.357 0 0 1-2.356-2.354v-4.684l-6.537-11.981a2.341 2.341 0 1 1 4.141-2.184l4.976 9.773 5-9.87a2.156 2.156 0 1 1 3.816 2.007l-6.686 12.255v4.684a2.357 2.357 0 0 1-2.354 2.354",
    transform: "translate(-653.274 -29.523)",
    style: {
      fill: "#5c626d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 169",
    d: "M709.769 59.244a2.276 2.276 0 0 1-2.274-2.274v-16.4a3.815 3.815 0 0 1 3.81-3.81h5.2c5.557 0 9.008 2.925 9.008 7.633a6.935 6.935 0 0 1-4.068 6.641l-.208.1 2.969 4.6a2.274 2.274 0 0 1-1.91 3.507h-.089a2.319 2.319 0 0 1-1.88-1.132L715.22 49.8a1.244 1.244 0 0 1 1.059-1.895c2.875 0 4.524-1.28 4.524-3.513s-1.649-3.514-4.524-3.514h-3.474a.6.6 0 0 0-.6.6V56.97a2.276 2.276 0 0 1-2.274 2.274z",
    transform: "translate(-568.165 -29.523)",
    style: {
      fill: "#5c626d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 170",
    d: "M295.975 59.625a2.479 2.479 0 0 1-2.316-1.612L287.883 42.4l-5.8 15.737a2.282 2.282 0 0 1-2.133 1.488 2.273 2.273 0 0 1-2.114-3.109l6.693-16.94a3.845 3.845 0 0 1 7.152 0l6.587 16.672a2.469 2.469 0 0 1-2.3 3.376",
    transform: "translate(-222.992 -29.829)",
    style: {
      fill: "#5c626d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 171",
    d: "M949.411 55.388c-6.595 0-11.381-4.969-11.381-11.816s4.786-11.816 11.381-11.816 11.382 4.969 11.382 11.816-4.787 11.816-11.382 11.816m0-19.429c-4.04 0-6.971 3.2-6.971 7.613s2.932 7.613 6.971 7.613 6.972-3.2 6.972-7.613-2.932-7.613-6.972-7.613",
    transform: "translate(-753.299 -25.502)",
    style: {
      fill: "#5c626d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 172",
    d: "m1023.107 121.626-1.867-2.472a2.3 2.3 0 1 1 3.671-2.773l1.867 2.472a2.3 2.3 0 1 1-3.671 2.773",
    transform: "translate(-819.748 -92.728)",
    style: {
      fill: "#5c626d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 173",
    d: "M9.907 36.421a4.089 4.089 0 0 1-2.607-.935A20.024 20.024 0 0 1 18.092.1a19.89 19.89 0 0 1 14.659 4.47 4.106 4.106 0 1 1-5.219 6.34 11.812 11.812 0 1 0-15.014 18.24 4.106 4.106 0 0 1-2.612 7.276",
    style: {
      fill: "#008ded"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 227"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 226",
    style: {
      clipPath: "url(#ppacnkilvb)"
    },
    transform: "translate(5.692 3.538)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 6366",
    transform: "rotate(-37.776 11.045 33.76)",
    style: {
      fill: "url(#y53xc5kr7c)"
    },
    d: "M0 0h50.396v50.701H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 229"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 228",
    style: {
      clipPath: "url(#u38goe8lva)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 175",
    d: "M138.936 24.695a4.1 4.1 0 1 1-.56-5.773 4.1 4.1 0 0 1 .56 5.773",
    transform: "translate(-105.738 -14.445)",
    style: {
      fill: "#17c3b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 176",
    d: "M36.126 149.5a4.1 4.1 0 1 1-.56-5.773 4.1 4.1 0 0 1 .56 5.773",
    transform: "translate(-23.175 -114.668)",
    style: {
      fill: "#17c3b2"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVoryq);
export default __webpack_public_path__ + "static/media/logo-voryq.b9246201.svg";
export { ForwardRef as ReactComponent };